import script from "./HeroSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeroSection.vue?vue&type=script&lang=ts&setup=true"

import "./HeroSection.vue?vue&type=style&index=0&id=a143e212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a143e212"]])

export default __exports__